/**
 * R2IT Golf Scoring API
 * This swagger document describes the available API endpoints.
 *
 * OpenAPI spec version: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { MicrosoftAspNetCoreMvcProblemDetails } from '../model/microsoftAspNetCoreMvcProblemDetails';
import { ModulesToursApplicationToursTourResponse } from '../model/modulesToursApplicationToursTourResponse';
import { ModulesToursEndpointsContractsToursCreateTourRequest } from '../model/modulesToursEndpointsContractsToursCreateTourRequest';
import { ModulesToursEndpointsContractsToursUpdateTourRequestModel } from '../model/modulesToursEndpointsContractsToursUpdateTourRequestModel';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { ToursServiceInterface }                            from './tours.serviceInterface';


@Injectable()
export class ToursService implements ToursServiceInterface {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Gets a Tour.
     * Gets a Tour using the Tour identifier.
     * @param tourId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getTourByIdEndpoint(tourId: string, observe?: 'body', reportProgress?: boolean): Observable<ModulesToursApplicationToursTourResponse>;
    public getTourByIdEndpoint(tourId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ModulesToursApplicationToursTourResponse>>;
    public getTourByIdEndpoint(tourId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ModulesToursApplicationToursTourResponse>>;
    public getTourByIdEndpoint(tourId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (tourId === null || tourId === undefined) {
            throw new Error('Required parameter tourId was null or undefined when calling getTourByIdEndpoint.');
        }

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ModulesToursApplicationToursTourResponse>('get',`${this.basePath}/tours/${encodeURIComponent(String(tourId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets all Tours.
     * Gets all Tours.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getToursEndpoint(observe?: 'body', reportProgress?: boolean): Observable<Array<ModulesToursApplicationToursTourResponse>>;
    public getToursEndpoint(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ModulesToursApplicationToursTourResponse>>>;
    public getToursEndpoint(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ModulesToursApplicationToursTourResponse>>>;
    public getToursEndpoint(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ModulesToursApplicationToursTourResponse>>('get',`${this.basePath}/tours`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Creates a Tour.
     * Creates a Tour based on the CreateTourRequest request.
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public toursPost(body?: ModulesToursEndpointsContractsToursCreateTourRequest, observe?: 'body', reportProgress?: boolean): Observable<string>;
    public toursPost(body?: ModulesToursEndpointsContractsToursCreateTourRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public toursPost(body?: ModulesToursEndpointsContractsToursCreateTourRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public toursPost(body?: ModulesToursEndpointsContractsToursCreateTourRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<string>('post',`${this.basePath}/tours`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Removes a Tour.
     * Removes a Tour using the Tour identifier.
     * @param tourId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public toursTourIdDelete(tourId: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public toursTourIdDelete(tourId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public toursTourIdDelete(tourId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public toursTourIdDelete(tourId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (tourId === null || tourId === undefined) {
            throw new Error('Required parameter tourId was null or undefined when calling toursTourIdDelete.');
        }

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('delete',`${this.basePath}/tours/${encodeURIComponent(String(tourId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Updates a Tour.
     * Updates a Tour based on the Tour idenfier and UpdateTourRequest.
     * @param tourId 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public toursTourIdPut(tourId: string, body?: ModulesToursEndpointsContractsToursUpdateTourRequestModel, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public toursTourIdPut(tourId: string, body?: ModulesToursEndpointsContractsToursUpdateTourRequestModel, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public toursTourIdPut(tourId: string, body?: ModulesToursEndpointsContractsToursUpdateTourRequestModel, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public toursTourIdPut(tourId: string, body?: ModulesToursEndpointsContractsToursUpdateTourRequestModel, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (tourId === null || tourId === undefined) {
            throw new Error('Required parameter tourId was null or undefined when calling toursTourIdPut.');
        }


        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('put',`${this.basePath}/tours/${encodeURIComponent(String(tourId))}`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
